import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { AgGridReact } from 'ag-grid-react';
import {
  indexOf, delay, each, map,
} from 'lodash';
import SearchField from '../../../../components/search-field';

class TagTable extends Component {
  constructor() {
    super();
    this.state = {
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.onFirstDataRendered();
  }

  onFirstDataRendered() {
    if (this.gridApi && this.gridColumnApi) {
      this.gridApi.showLoadingOverlay();
      delay(() => {
        const { width } = this.props;
        const allColumns = this.gridColumnApi.getColumns();
        const allColumnIds = map(allColumns, 'colId');
        this.gridColumnApi.autoSizeColumns(allColumnIds);
        let allWidths = 0;
        each(this.gridColumnApi.getColumns(), (col) => {
          allWidths += col.actualWidth;
        });
        const viewableWidth = width;
        if (allWidths < viewableWidth - 2) {
          this.gridApi.sizeColumnsToFit();
        }
        const { selectedTags } = this.props;
        this.gridApi.forEachNode((node) => {
          const nodeData = node.data;
          if (nodeData) {
            const selected = indexOf(selectedTags, nodeData.id) >= 0;
            node.setSelected(selected);
          } else {
            node.setSelected(false);
          }
        });

        this.gridApi.hideOverlay();
      }, 500);
    }
  }

  onSelectionChanged() {
    if (!this.props.disabled && this.gridApi) {
      const selectedRows = this.gridApi.getSelectedRows();
      this.props.onSelectTags(selectedRows);
    }
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  render() {
    const {
      tags, width,
    } = this.props;
    
    const rowHeight = 45;
    const tableHeight = Math.min(202, (rowHeight * tags.length) + rowHeight + 2);
    const columnDefs = [
      {
        headerName: 'Tag',
        colId: 'NAME',
        field: 'name',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        checkboxSelection: true,
        headerCheckboxSelection: true,
      },
    ];
    return (
      <div>
        {tags.length >= 5 &&
          <nav className="navbar navbar-default navbar-controls">
            <div className="navbar-form navbar-left">
              <SearchField onSearch={this.handleSearch} />
            </div>
          </nav>
        }
        {tags.length > 0 &&
          <div className="ag-theme-alpine" style={{ width, height: tableHeight }}>
            <AgGridReact
              reactNext
              enableColResize
              enableSorting
              animateRows
              suppressColumnVirtualisation
              columnDefs={columnDefs}
              getRowNodeId={data => data.id}
              onGridReady={this.onGridReady}
              rowData={tags}
              rowSelection="multiple"
              onSelectionChanged={this.onSelectionChanged}
              rowHeight={rowHeight}
            />
          </div>
        }
      </div>
    );
  }
}

TagTable.propTypes = {
  tags: PropTypes.arrayOf.isRequired,
  selectedTags: PropTypes.arrayOf(),
  width: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  onSelectTags: PropTypes.func,
};
TagTable.defaultProps = {
  selectedTags: [],
  onSelectTags: () => {},
};

export default TagTable;
